import { autoinject, transient, useView } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import * as moment from "moment";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { RightshipRuleConfigParameterModel } from "../../../models/customers/customer.models";
import { NotificationClientService } from "../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../services/queries/queries-client.services";
import { BaseHistoryTrail } from "../common/base-history-trail";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
@useView('views/pages/settings/rightship-rule-history-trail.html')
export class RightshipRuleHistoryTrail extends BaseHistoryTrail<RightshipRuleConfigParameterModel> {

    public audits: any[] = [];
    private allAudits: any[] = []

    constructor(private queriesClientService: QueriesClientService, notificationClientService: NotificationClientService, i18N: I18N, configService: ConfigService) {
        super(configService, notificationClientService, i18N);
    }

    protected onActivated() {
        this.refreshData();
    }

    public refreshData() {
        this.allAudits = [];
        const ruleConfigParamAudits = this.queriesClientService.getData(`/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${EntityTypes.RightshipRuleConfigParameter},entityId=null)?$orderby=timestamp desc`);
        const zhpAudit = this.queriesClientService.getData(`/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${EntityTypes.ZeroharmPartner},entityId=null)?$orderby=timestamp desc`)
        
        Promise.all([ruleConfigParamAudits, zhpAudit].map(c=>c.then(k=> {
            this.allAudits = [...this.allAudits,...k.value]
        }))).then(() => { 
            this.audits = this.allAudits.sort(function(a, b) {
                return b.timestamp.localeCompare(a.timestamp)
            });
        }) ;

    }

    getFormattedDate(date) {
        return moment(date).format('DD MMM YYYY HH:mm');
    }
}